import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  TabNavigationCtrlFilterPanel: {
    margin: theme.sizes.spacing.default,
  },
  containers: {
    justifyContent: "center",
    // display: "flex",
    alignItems: "center",
    flex: 1,
  },
  navigation: {
    display: "flex",
    borderBottom: "2px #ccc solid",
    marginBottom: "7px",
    marginTop: theme.sizes.spacing.default,
  },
  navigationRoutes: {
    flex: 1,
  },
  navigationRoutesTabs: {
    width: "100%",
  },
  navigationRoutesTabsTab: {
    paddingTop: theme.sizes.spacing.minor,
    paddingBottom: theme.sizes.spacing.minor,
    fontWeight: "bold",
    fontSize: "1rem",
  },
  navigationControls: {
    textAlign: "right",
  },
  addButton: {
    boxShadow: "0 0 0",
    fontSize: "1.2rem",
    borderRadius: 0,
    maxWidth: "350px",
    height: "65px",
    width: "100%",
  },
}));

export default useStyles;
